import { EventLevel } from '../dtos/EventLevel'
import { AbstractModel } from './AbstractModel'
import { Team } from './Team'
import { User } from './User'
import { DateUtils } from '../utils/DateUtils'
import { EventType } from '../dtos/EventType'

export class EventLog extends AbstractModel {
  customer: User | null = null
  team: Team | null = null
  level: EventLevel | null = null
  type: string | null = null
  message: string | null = null
  createdAt: string | null = null
  updatedAt: string | null = null

  get eventAsMessage (): string {
    if (!this.createdAt || !this.customer) {
      return 'invalid'
    }
    let decodedMessage: any = {}
    if (this.message) {
      decodedMessage = JSON.parse(this.message)
    }

    switch (this.type) {
      case EventType.USER_REGISTER:
        return `${this.userString} hat sich am ${this.dateString} registriert!`
      case EventType.USER_LOGIN:
        return `${this.userString} hat sich am ${this.dateString} eingeloggt!`
      case EventType.USER_SEND_MESSAGE:
        return `${this.userString} hat am ${this.dateString} eine Nachricht in den Chat von Rally Runde ${decodedMessage.rallyRoundId} gesendet!`
      case EventType.USER_ADDED_TO_CUSTOMER_REGISTER:
        return `Nutzer ${this.userString} wurde  am ${this.dateString} von Nutzer mit ID ${decodedMessage.teamleadId} zur Registrierung mit ID ${decodedMessage.id} hinzugefügt.`
      case EventType.CREATE_CUSTOMER_REGISTER:
        return `${this.userString} hat am ${this.dateString} ein ${decodedMessage.teamSize}er Team für Rally Runde ${decodedMessage.rallyRound} angemeldet. Der Status der Registrierung war ${decodedMessage.status}`
      case EventType.SET_AUTO_PAYMENT:
        return `${this.userString} wurde am ${this.dateString} automatisch auf bezahlt gestellt!`
      case EventType.CHANGE_CUSTOMER_REGISTER_STATUS:
        return `Die Registrierung von ${this.userString} mit ID ${decodedMessage.id} wurde am ${this.dateString} von Status ${decodedMessage.newStatus} auf Status ${decodedMessage.newStatus} geändert.`
      case EventType.CUSTOMER_REGISTER_ADD_TEAMMEMBER:
        return `Nutzer ${this.userString} hat am ${this.dateString} Nutzer mit ID ${decodedMessage.memberId} zur Registrierung mit ID ${decodedMessage.id} hinzugefügt.`
      case EventType.USED_FIXED_VALUE_DISCOUNT:
        return `Nutzer ${this.userString} hat am ${this.dateString} einen fixen Eurowert Discount mit Namen ${decodedMessage.name} benutzt und ${decodedMessage.amount}€ aufgebraucht.`
      case EventType.SEND_DOWNLOAD_READY_MAIL:
        return `${this.userString} hat am ${this.dateString} eine Download bereit Mail bekommen`
      case EventType.SEND_FIRST_INFO_MAIL:
        return `${this.userString} hat am ${this.dateString} eine erste Infos Mail bekommen`
      case EventType.SEND_TEAMNUMBER_REMINDER_MAIL:
        return `${this.userString} hat am ${this.dateString} eine Startnummer Erinnerungs Mail bekommen`
      case EventType.SEND_TEAMMEMBER_REMINDER_MAIL:
        return `${this.userString} hat am ${this.dateString} eine Teammitglied hinzufügen Erinnerungs Mail bekommen`
      case EventType.SEND_PAYMENT_REMINDER_MAIL:
        return `${this.userString} hat am ${this.dateString} eine Zahlungserinerungs Mail bekommen`
      case EventType.SEND_WAITLIST_MAIL:
        return `${this.userString} hat am ${this.dateString} eine Warteliste Mail bekommen`
      case EventType.SEND_MOVED_UP_WAITLIST_MAIL:
        return `${this.userString} hat am ${this.dateString} eine von der Warteliste hochgerückt Mail bekommen`
      case EventType.SEND_CANCELLED_MAIL:
        return `${this.userString} hat am ${this.dateString} eine storniert Mail bekommen`
      case EventType.SEND_NEW_TEAMMEMBER_PAYMENT_MAIL:
        return `${this.userString} hat am ${this.dateString} eine neues Teammitglied bezahlen Mail bekommen`
      case EventType.SEND_RALLY_REGISTER_CONFIRMATION_MAIL:
        return `${this.userString} hat am ${this.dateString} eine Rally Registrierungsbestätigungs Mail bekommen`
      case EventType.SEND_PASSWORD_RESET_MAIL:
        return `${this.userString} hat am ${this.dateString} eine Passwort zurücksetzen Mail bekommen`
      case EventType.SEND_ADD_TEAMMEMBER_MAIL:
        return `${this.userString} hat am ${this.dateString} eine Teammitglied hinzugefügt Mail bekommen`
      case EventType.SEND_STATUS_UPDATE_MAIL:
        return `${this.userString} hat am ${this.dateString} eine Status update Mail bekommen`
      case EventType.POST_ACTION:
        return `${this.userString} hat am ${this.dateString} auf die Adresse ${decodedMessage.route} per POST folgende Parameter: ${decodedMessage.params} und folgenden Body: ${decodedMessage.body} gesendet`
      case EventType.PUT_ACTION:
        return `${this.userString} hat am ${this.dateString} auf die Adresse ${decodedMessage.route} per PUT folgende Parameter: ${decodedMessage.params} und folgenden Body: ${decodedMessage.body} gesendet`
      case EventType.DELETE_ACTION:
        return `${this.userString} hat am ${this.dateString} auf die Adresse ${decodedMessage.route} per DELETE folgende Parameter: ${decodedMessage.params} und folgenden Body: ${decodedMessage.body} gesendet`
    }
    return 'invalid'
  }

  get userString (): string {
    if (!this.customer) {
      return 'Unbekannter Nutzer'
    }
    return `${this.customer.firstname} ${this.customer.lastname} (${this.customer.email})`
  }

  get dateString (): string {
    if (!this.createdAt) {
      return 'unbekanntes Datum'
    }
    const createdAtDate = new Date(this.createdAt)
    return `${DateUtils.dateToEuropeString(createdAtDate)} ${createdAtDate.getHours()}:${createdAtDate.getMinutes()}`
  }
}
